export default __webpack_public_path__ + "static/media/BodyGame_10.4b1f865c.png";